// ─── Global Layout Constants ────────────────────────────────────────────────
// Single source of truth for all spacing, sizing and breakpoint values.
// Never repeat these values inline — always import from here.

// Page
export const PAGE_PADDING = 24;
export const PAGE_PADDING_MOBILE = 12;
export const SECTION_GAP = 20;

// Cards
export const CARD_PADDING = 20;
export const CARD_PADDING_SM = 14;

// Forms
export const FIELD_GAP = 16;
export const LABEL_GAP = 6;
export const SECTION_SPACING = 24;

// Tables
export const TABLE_TOOLBAR_HEIGHT = 48;
export const TABLE_ROW_HEIGHT = 40;

// Navigation
export const HEADER_HEIGHT = 48;
export const SIDEBAR_WIDTH = 220;
export const SIDEBAR_COLLAPSED_WIDTH = 56;
export const BREAKPOINT_SIDEBAR = 1190;
export const BREAKPOINT_LAPTOP = 1280;
export const BREAKPOINT_TABLET = 1024;

// Content
export const CONTENT_MAX_WIDTH = 1800;
